<script setup lang="ts">
import { AppSvgIcon } from '@libs/ui';

interface DealCodeTagProps {
  wrap?: boolean;
}

const props = withDefaults(defineProps<DealCodeTagProps>(), { wrap: false });

const dealCode = 'Spring2025';
</script>

<template>
  <div class="deal-code-tag" :class="{ wrap: props.wrap }">
    <AppSvgIcon name="priceLabel" size="18" />
    <span class="deal-code-text">{{ $t('planner.with_code') }}:</span>
    <div>{{ dealCode }}</div>
  </div>
</template>

<style scoped lang="scss">
.deal-code-tag {
  display: flex;
  align-items: center;
  gap: var(--spacing-4);
  justify-content: flex-end;
  color: var(--color-neutral-70);
  @include font-label-s-bold;

  &.wrap {
    flex-wrap: wrap;
  }

  .deal-code-text {
    text-align: right;
    white-space: nowrap;
    @include font-label-s-light;
  }
}
</style>
